<template>
  <modal-layout :is-open="isOpen" @close="modalClose">
    <div class="Modal_area Explanation__modal_area">
      <div class="Modal__cross-box _cross" @click="modalClose">
        <span class="Modal__cross" />
      </div>
      <div class="Modal_inner Explanation__modal_inner Explanation__modal_inner--pd_lr">
        <div class="Explanation__class">
          <ul class="Explanation__class_list">
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="BASIC" src="assets/img/ph_lesson01.jpg"><span>BASIC</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson02.png">
                <p>マインドフルネス瞑想の基本、呼吸を観察する方法を学びます。過去や未来をさまよっている心を今ここに呼び戻し、その一瞬一瞬を感じ続けます。全てのマインドフルネスのベースになるトレーニングですので、時間をかけて確実に身につけましょう。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="RECOGNITION" src="assets/img/ph_lesson02.jpg"><span>RECOGNITION</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson03.png">
                <p>マインドフルネスで一番大切なのは、自分自身を観察をして気づくこと。ジャーナリングやラベリングという方法で、ご自身の心や思考を観察するプログラムです。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="HEART" src="assets/img/ph_lesson03.jpg"><span>HEART</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson04.png">
                <p>マインドフルネスでとても大切な要素、他人や自分を大切に思う気持ちを育むプログラムです。セルフコンパッションという自分への共感力を伸ばし、他人への優しい気持ちに広げていきます。</p>
              </div>
            </li>
            <li class="Explanation__class_list_item">
              <div class="Explanation__class_list_sub">
                <img class="Explanation__class_list_sub_img" alt="WHAT’S MINDFULNESS" src="assets/img/ph_lesson04.jpg"><span>WHAT’S MINDFULNESS</span>
              </div>
              <div class="Explanation__class_list_main">
                <img class="Explanation__class_list_main_img" alt="" src="assets/img/icon_lesson05.png">
                <p>マインドフルネスの理論を学ぶクラスです。マインドフルネスは実践を積み重ねて初めて効果が感じられるものですが、その背景にある考え方を理解することでより実践が深まります。</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/views/components/modals/ModalLayout.vue'

export default {
  name: 'Recommend01',
  components: { ModalLayout },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    modalClose() {
      this.$emit('close')
    }
  }
}
</script>
